// Shared defaults for MUI and CSS. Pass overrides to AppTheme to apply a palette.
export const DEFAULT_COLORS = Object.freeze({
  orange: "#e67221",
  charcoal: "#222222",
  white: "#ffffff",
  black: "#000000",
  pageDark: "#121212",
  pageLight: "#f8f9fa",
  secondaryDark: "#dfb7a5",
  secondaryLight: "#422318",
  mutedLight: "#f5f5f5",
  outline: "#71717a",
  midGray: "#888888",
  rowDivider: "#333333",
  badgeBlue: "#2563eb",
  badgeGreen: "#15803d",
  badgeOrange: "#b45309",
  badgeRed: "#dc2626",
  syncNever: "#b42332",
  syncAsk: "#62676e",
  syncAlways: "#18713e",
});

export const colorVariables = (colors) =>
  Object.fromEntries(
    Object.entries(colors).map(([name, value]) => [
      `--color-${name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`,
      value,
    ]),
  );
